module.exports = __webpack_public_path__ + "static/travel2023-93dedf71d9b7ae4fdbd00e556340bb69.webp";